import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AppConfigService } from 'src/modules/shared/services/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class NewsManagementService {
  public baseURL: string;

  constructor(private http: HttpClient, private appConfig: AppConfigService) {
    this.baseURL = this.appConfig.getAppConfig().AppUrl + '/api/App/';
  }
   
  // GET LIST OF NEWS
  getNewsList(body): Observable<any> {
    return this.http.post<object>(this.baseURL + 'GetNews', body);
  }

  // GET SINGLE NEW
  getNewsItem(params) {
    return this.http.get(this.baseURL + 'GetNewsDetails', {params: params});
  }

  // Error handling
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

}
